export abstract class S3ProductPublicService {
  protected readonly bucketBaseUrl = 'https://ana-monitor-secas-files.s3.sa-east-1.amazonaws.com';
  protected readonly monthPrefix = 'uploads/produtos/srm_persist/';
  protected readonly fallbackMonthsToProbe = 24;

  async listAvailableMonths(): Promise<string[]> {
    try {
      const url = `${this.bucketBaseUrl}/?list-type=2&prefix=${encodeURIComponent(this.monthPrefix)}&delimiter=/`;
      const res = await fetch(url, { method: 'GET' });
      if (!res.ok) {
        throw new Error(`Erro HTTP ${res.status}`);
      }

      const xml = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(xml, 'application/xml');

      const months = Array.from(
        new Set(
          Array.from(doc.getElementsByTagName('Prefix'))
            .map(node => (node.textContent || '').trim())
            .filter(prefix => prefix.length > 0)
            .map(prefix => prefix.replace(this.monthPrefix, '').replace(/\/$/, ''))
            .filter(prefix => /^\d{6}$/.test(prefix))
        )
      ).sort().reverse();

      if (months.length > 0) {
        return this.filterMonthsWithProductImages(months);
      }
    } catch {
      // Se a listagem pública falhar, tenta detectar os meses por imagens públicas do produto.
    }

    return this.probeRecentMonths();
  }

  private async filterMonthsWithProductImages(months: string[]): Promise<string[]> {
    const checks = await Promise.all(
      months.map(async month => ({
        month,
        exists: await this.imageExists(this.buildProbeImageUrl(month))
      }))
    );

    return checks.filter(item => item.exists).map(item => item.month);
  }

  private async probeRecentMonths(): Promise<string[]> {
    const candidates: string[] = [];
    const now = new Date();

    for (let offset = 0; offset < this.fallbackMonthsToProbe; offset += 1) {
      const date = new Date(now.getFullYear(), now.getMonth() - offset, 1);
      const month = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}`;
      candidates.push(month);
    }

    return this.filterMonthsWithProductImages(candidates);
  }

  protected abstract buildProbeImageUrl(month: string): string;

  protected imageExists(url: string): Promise<boolean> {
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  }
}
